module.exports = __webpack_public_path__ + "static/media/washington-dc-70.ed15be34.jpg";